"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./TRCToggle.css");

var _atoms = require("../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
function TRCToggle(props) {
  var className = "TRCToggle " + (props.primary ? "primary" : "");
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    trkAction: props.trkAction,
    className: className,
    onClick: props.onToggle
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    onChange: props.onToggle,
    checked: props.checked
  }), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "switch-label"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "switch-rail"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "letterOn"
  }, "On"), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "switch-slider"
  }), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "letterOff"
  }, "Off"))));
}

var _default = TRCToggle;
exports.default = _default;